import React                            from 'react';
import colors                           from '../../utils/colors';
import PlayCircleFilledWhiteRoundedIcon from '@material-ui/icons/PlayCircleFilledWhiteRounded';
import ForwardRoundedIcon               from '@material-ui/icons/ForwardRounded';
import { makeStyles }                   from '@material-ui/core/styles';
import { words }                        from '../../utils/dictionary';

var clsx = require('classnames');


const useStyles = makeStyles(theme => ({
  options: {
    width:          '100%',
    display:        'flex',
    justifyContent: 'space-around',
    alignItems:     'center',
  },
  button_container: {
   // flex:           1,
    position:       'fixed',
    top:            '50%',
    left:           '50%',
    height:         300,
    width:          '100vw',
    display:        'flex',
    justifyContent: 'center',
    alignItems:     'center',
    transition:     'all 1s'
  },
  column: {
    flexFlow: 'column'
  },
  button_and_text: {
    width:           300,
    height:          250,
    display:         'flex',
    justifyContent:  'center',
    alignItems:      'center',
    flexFlow:        'column',
  },
  button: {
    width:           190,
    height:          90,
    display:         'flex',
    justifyContent:  'center',
    alignItems:      'center',
    transition:      'transform 1s, width 0.4s',
    border:          '1px solid #FFF',
    cursor:          'pointer',
    borderRadius:    '1em',
    '&:hover': {
      width: 250
    }
  },
  pink: {
    backgroundColor: colors.pink,
  },
  blue: {
    backgroundColor: colors.blue_,
  },
  icon: {
    color:    '#FFF',
    fontSize: 50
  },
  button_text: {
    color:           '#FFF',
    width:           '100%',
    fontSize:        30,
    fontWeight:      'bold',
    textAlign:       'center',
    paddingTop:      '0.4em',
    paddingBottom:   '0.4em',
    borderRadius:    '0.5em',
    marginTop:       10,
    cursor:          'pointer',
    textShadow:      '0px 2px 2px #000',
    transition:      'transform 2s, opacity 0.4s',
    '&:hover': {
      opacity: 0.5
    }
  },
  p: {
    color:      '#FFF',
    fontSize:   34,
    fontWeight: 1000
  }
}));

type ButtonsProps = {
     size:          number[];
     selected:      boolean;
     buttonPos:     boolean;
     lang:          string;
     dir:           string;
     setButtonPos:  (val: boolean) => void;
     handlePlay:    () => void;
     handleContinue:() => void;
}

const Buttons: React.FC<ButtonsProps> = ({
      size,
      selected,
      buttonPos,
      lang,
      dir,
      setButtonPos,
      handlePlay,
      handleContinue
  }) => {


  const classes = useStyles();

  React.useEffect(() => {
    setTimeout(() => { setButtonPos(true) },10)
  },[setButtonPos])

  return (
    <div
       className = { size[0] > 600 ? classes.button_container : clsx(classes.button_container, classes.column) }
       style     = {{
        transform: `translate(-50%, ${ buttonPos ? -50 : 1000 }%)`
      }}
    >
            <div className = { classes.button_and_text }>
                  <div 
                    className = { clsx(classes.button, classes.pink) }
                    onClick   = { handlePlay }
                  >
                    <PlayCircleFilledWhiteRoundedIcon className = { classes.icon }/>
                  </div>
                  <div 
                     dir       = { dir }
                     className = { classes.button_text }
                     onClick   = { handlePlay }
                     style     = {{
                      transform: `translate(0px, ${ buttonPos ? 0 : 100 }vh)`
                    }}
                  >
                    { (selected && `${ words['replay'][lang] }`) || (!selected && `${ words['play'][lang] }`) }
                  </div>
            </div>
            {
              selected
              &&
              <div className = { classes.button_and_text }>  
                  <div 
                    className = { clsx(classes.button, classes.blue) }
                    onClick   = { () => { setButtonPos(false); handleContinue() }}
                  > 
                    <ForwardRoundedIcon className = { classes.icon }/>
                </div>
                <div 
                  dir       = { dir }
                  className = { classes.button_text }
                  onClick   = { () => { setButtonPos(false); handleContinue() }}
                  style     = {{
                      transform: `translate(0px, ${ buttonPos ? 0 : 100 }vh)`
                  }}
                >
                  { `${ words['continue'][lang] }` }
                </div>
             </div>
            }
       
    </div>
  )
}

export default Buttons

